import slice from "./retailersSlice";

export default slice.reducer;
